import styled from 'styled-components'

import Footer from '~/components/Footer'
import SideNav from '~/components/SideNav'
import { TopNavigation } from '~/components/TopNav'
import { AppDimensions } from '~/constants'

const AppSideBar = styled.div`
  overflow: hidden;
  z-index: 100;
  position: sticky;
  top: ${AppDimensions.navBarHeight};
  height: calc(100vh - ${AppDimensions.navBarHeight});
  ${({ theme }) => theme.mediaQuery.maxWidth.mobileLarge} {
    /* relocate nav to floating button */
    position: fixed;
    top: unset;
    height: unset;
    bottom: 0px;
    /* add space for drop-shadow on child element */
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.colorTokens.border['border-subdued']};
  }
`

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div data-name='app-layout' className='flex flex-col min-h-screen'>
      <TopNavigation />
      <div data-name='app-layout-container' className='flex flex-col-reverse sm:flex-row flex-1'>
        <AppSideBar data-name='app-side-bar'>
          <SideNav />
        </AppSideBar>
        <div
          data-name='app-layout-content'
          className='flex flex-col flex-1 justify-between bg-yellow-gradient-1 overflow-x-hidden overflow-y-auto pb-[110px] sm:pb-0'
        >
          <div data-name='app-layout-content-children' className='flex-1'>
            {children}
          </div>
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default AppLayout
